<ng-container *ngIf="showPaginator">
	<mat-paginator
		class="cart-paginator"
		*ngIf="groups.length > paginatorPageSize"
		[pageIndex]="paginatorCurrentPage-1"
		[pageSize]="paginatorPageSize"
		[length]="groups.length"
		[hidePageSize]="true"
		[showFirstLastButtons]="(groups.length / paginatorPageSize) > 2"
		(page)="updatePagination($event.pageIndex)"
	></mat-paginator>
</ng-container>

<mat-accordion multi="true">
	<mat-expansion-panel
		class="cart-panel"
		*ngFor="let group of groups | slice:
			paginatorPageSize * (paginatorCurrentPage-1):
			showPaginator ? this.paginatorCurrentPage * this.paginatorPageSize : groups.length;
			let isLast = last"
		togglePosition="before"
		[ngClass]="{'last': isLast && (mode === 'list' || mode === 'post-checkout')}"
		[disabled]="!showExpandableDetails || ((mode !== 'list' && mode !== 'post-checkout') || groups.length === 1)"
		[expanded]="showExpandableDetails && groups.length === 1"
	>
		<mat-expansion-panel-header>
			<div class="header">
				<app-cart-list-group-row
					class="pb-1 block full-width"
					[group]="group"
					[mode]="mode"
					[showHeader]="showHeader"
					[showThumbnail]="showExpandableDetails ? groups.length !== 1 : true"
					[showSizeCount]="showSizeCount"
					[showGroupActions]="showGroupActions"
					[showReview]="showReview"
					[showExport]="showExpandableDetails"
					[showExpandableDetails]="showExpandableDetails"
					[highlightQuery]="highlightQuery"
					[actionInProgress]="actionInProgress"
					[useItemTranslations]="useItemTranslations"
					[forcePanelsOpen]="forcePanelsOpen"
					[expandedItems]="expandedItems"
					(expandedChange)="expandedItems[$event.key] = $event.state"
					(goToGroup)="goToGroup.emit($event)"
					(goToItem)="goToItem.emit({ item: $event.item, group: $event.group })"
					(deleteItems)="deleteItems.emit($event)"
					(deleteItem)="deleteItems.emit({ items: [$event], mode: DeleteCartItemMode.Item })"
					(exportItem)="exportItem.emit($event)"
					(groupAction)="groupAction.emit($event)"
					(itemAction)="itemAction.emit($event)"
				></app-cart-list-group-row>
			</div>
		</mat-expansion-panel-header>

		<ng-container *ngIf="showExpandableDetails">
			<ng-container *ngIf="(mode === 'list' || mode === 'post-checkout')">
				<div *ngIf="group.type === CartItemType.AD_UNIT"  #adPreviewContainer class="expandable-section mt-2 pt-2 pb-2" [style.min-height.px]="group.items | transformObject: getMinHeight">
					<div class="ad-preview-container scrollbar-thin ml-6">
<!--						<app-ad-preview-->
<!--							[creativeUnits]="group.items | transformObject :transformItemsToCreativeUnit "-->
<!--							[fitToElement]="adPreviewContainer"-->
<!--							[showTitle]="false"-->
<!--							[showSize]="true"-->
<!--							[metadataPosition]="'above'"-->
<!--							[background]="'transparent'"-->
<!--							[padding]="0"-->
<!--						></app-ad-preview>-->
					</div>
				</div>

				<ng-container *ngIf="group.type === CartItemType.VIDEO">
					<div  class="expandable-section mt-2 pt-2 pb-3" *ngIf="group.items?.[0]?.encodeJob?.encodeTasks?.[0]?.result.path as previewPath">
						<div class="video-container mt-1 ml-6">
							<video [src]="previewPath" controls controlsList="nodownload"></video>
						</div>
					</div>
				</ng-container>

			</ng-container>
		</ng-container>

	</mat-expansion-panel>
	<mat-expansion-panel *ngIf="mode==='checkout'" class="cart-panel last total" togglePosition="before" [disabled]="true">
		<mat-expansion-panel-header>
			<div class="header flex justify-space-between">
				<span i18n="Total Price in Cart@@cartListTotalPriceInCartLabel">Total</span>
				<span class="total-price">{{0 | currency: 'USD': 'symbol'}}</span> <!-- TODO: add total price -->
			</div>
		</mat-expansion-panel-header>

	</mat-expansion-panel>
</mat-accordion>
